import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const catNavContainerSX:SxProps = {
    bgcolor:'inherit',
    p:2, 
    mb:2,
    boxShadow:0,
    border:'none',
    '& .hidden':{
        display:'none'
    }
}

export const catNavContainerMobSX:SxProps = {
    display:'flex',
    columnGap:2.5,
    overflowX:'auto',
    border:'none',
    boxShadow:'unset'
}

export const catNavCategorySX:SxProps = {
    mb:1,
}

export const categoryNavSX:SxProps = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
}

export const catNavCategoryMobSX:SxProps = {
    border: '1px solid #dddcdc',
    bgcolor:'#f9fbfb',
    p: 1,
    maxWidth: '10em',
    '& a':{
        width:'9em',
        textAlign:'center',
        color:'#353535',
        display: 'flex',
        wordBreak: 'break-all',
        alignItems:'center'
    }
}

export const catNavHeaderSX:SxProps = {
    display:globalBreak(({mobile:'none', desktop:'block'})),
    mb:1,
    fontSize:16
}
